// Normalização usada SÓ pela regra de divergência de nível CRM (sync-level).
//
// As duas pontas comparadas não falam a mesma língua: o core guarda um slug
// ("nivel_12") e a Smartico entrega o NOME do degrau ("NÍVEL 12", com acento e
// às vezes um sufixo depois de " - "). Passar os dois pelo mesmo funil é o que
// torna a comparação possível sem depender do formato exato de nenhum lado —
// se o core mudar o separador ou a Smartico mudar a caixa, os dois continuam
// caindo no mesmo slug.
export function normalizeCrmLevelSlug(value: unknown): string | null {
  if (typeof value !== 'string') return null;

  const slug = value
    // O nome da Smartico pode vir composto ("NÍVEL 12 - Bronze"): só o trecho
    // antes do separador identifica o degrau — é a mesma leitura que o
    // `currentUserLevelName` da store já faz pra exibição.
    .split(' - ')[0]!
    .normalize('NFD')
    .replace(/[\u0300-\u036F]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');

  return slug || null;
}
